import { render, staticRenderFns } from "./CteDetalhes.vue?vue&type=template&id=590a7789"
import script from "./CteDetalhes.vue?vue&type=script&lang=js"
export * from "./CteDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports